export enum SimXInstitutionEntityAttribute {
  Active = 'active',
  Code = 'code',
  CreatedAt = 'createdAt',
  Expiration = 'expiration',
  Id = 'id',
  InstitutionReleaseTags = 'institutionReleaseTags',
  InstitutionScenarioPackages = 'institutionScenarioPackages',
  InstitutionUsers = 'institutionUsers',
  Name = 'name',
  ReportingCodes = 'reportingCodes',
  SimSessions = 'simSessions',
  SimulationOptions = 'simulationOptions',
  Tags = 'tags',
  Type = 'type',
  UpdatedAt = 'updatedAt',
}
